/* Woodlit G6 homepage (Pergolux SB-P0). One IIFE, plain ES5, every block in its own try.
   1. Delegated click tracking for G6's own elements through G1's window.wlTrack (placement and value only).
      WhatsApp and tel: links carry no G6 attribute: G1's listener counts them once.
   2. 'New' date reveal for G5-style cards in the G6 product row (SB-P1P2, card_mode g5 only; inert in theme mode).
   SB-P1P2 adds the hero dialog, the hero-in-view observer and the Guinness watch button here. */
(function () {
  'use strict';
  if (window.__wlG6) return;
  window.__wlG6 = true;

  try {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var el = t && t.closest ? t.closest('[data-wl-g6-track]') : null;
      if (!el || typeof window.wlTrack !== 'function') return;
      var props = { placement: el.getAttribute('data-wl-g6-placement') || '' };
      var v = el.getAttribute('data-wl-g6-value');
      if (v) props.value = v;
      window.wlTrack(el.getAttribute('data-wl-g6-track'), props);
    }, true);
  } catch (e) {}

  function revealNew() {
    try {
      var dated = document.querySelectorAll('.wl-g6-products [data-wl-new-until]');
      if (!dated.length) return;
      var today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      for (var i = 0; i < dated.length; i++) {
        if (today <= dated[i].getAttribute('data-wl-new-until')) { dated[i].hidden = false; }
        else if (dated[i].parentNode) { dated[i].parentNode.removeChild(dated[i]); }
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealNew);
  } else {
    revealNew();
  }
})();
